<style scoped lang="less" src="./../assets/Loading.less"></style>
<template>
  <div class="loading-mask" v-if="isLoading"></div>
</template>
<script>
  export default {
    name: 'Loading',
    data() {
      return {
      };
    },
    props: {
      isLoading: Boolean
    },
    watch: {
      isLoading: {
        handler(value) {
          if (value) {
            setTimeout(() => {
              this.$store.dispatch('setLoading', { state: false });
            }, 6000);
          }
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Loading.vue?2a7462ae